define('home/views/ExploreChannelGroupsReactViewWrapper',[
    'underscore',
    'backbone-marionette',

    'home/mixins/withReactSubviews',
    'home/utils/navigationUtils',
], function (
    _,
    Marionette,

    withReactSubviews,
    navigationUtils
) {
    'use strict';

    /**
     * An empty Marionette view that simply renders the react ExploreChannelGroupsView
     * into itself. This is done so that any TabbedViews that wish to render the
     * ExploreChannelGroupsView into their content area have a Marionette view that they
     * can render, as they expect.
     */
    var ExploreChannelGroupsReactViewWrapper = Marionette.ItemView.extend({
        template: function () {
            return '';
        },

        initialize: function (options) {
            this.channelGroupsCollection = options.channelGroupsCollection;
            this.rankings = options.rankings;
            this.explorePath = options.explorePath;
        },

        /**
         * Returns the channel groups as a non-backbone data structure to
         * be passed to the react view.
         *
         * @returns {Object[]} - an array of channel group objects
         */
        getChannelGroups: function () {
            return this.channelGroupsCollection.invoke('toJSON');
        },

        onDomRefresh: function () {
            // If the Backbone Collection is fetching, listen for it to
            // complete and update the component props once it does
            if (!this.channelGroupsCollection.length) {
                this.channelGroupsCollection.once('sync', _.bind(function () {
                    this.updateComponentProps(
                        this.constructor.COMPONENTS.CONTENT,
                        { channelGroups: this.getChannelGroups() }
                    );
                }, this));
            }

            this.renderReactSubview(
                this.constructor.COMPONENTS.CONTENT,
                {
                    channelGroups: this.getChannelGroups(),
                    rankings: this.rankings,
                    navigationUtils: navigationUtils,
                    explorePath: this.explorePath,
                },
                this.$el[0]
            );
        },
    }, {
        COMPONENTS: {
            CONTENT: 'core/views/react/ExploreChannelGroupsView',
        },
    });

    withReactSubviews.call(ExploreChannelGroupsReactViewWrapper.prototype,
        ExploreChannelGroupsReactViewWrapper.COMPONENTS);

    return ExploreChannelGroupsReactViewWrapper;
});

